import React from 'react';
import { buildApaQuoteContent } from '../../lib/apaSlideFormatter.js';

const ApaQuoteRenderer = ({ block, isEditMode = false }) => {
  const { quoteText, citationText, citationLink } = buildApaQuoteContent(block);
  const quoteBody = quoteText || 'Add your quote or paraphrase text to highlight an APA citation.';

  return (
    <div className="rounded-2xl border border-indigo-200 bg-indigo-50/60 p-5 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          {/* The block-type badge is an authoring affordance: it tells the
              editor which block they are in. Preview and presentation show the
              quote as the audience should read it, so the badge stays behind
              edit mode — matching the HTML/PPTX exports, which never emit it. */}
          {isEditMode && (
            <span className="inline-flex items-center gap-2 rounded-full bg-indigo-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-indigo-700">
              ❝ APA Quote/Paraphrase
            </span>
          )}
          <blockquote className={`${isEditMode ? 'mt-4 ' : ''}text-lg italic text-slate-700`}>
            {quoteBody}
          </blockquote>
          <div className="mt-4 text-sm text-slate-600">
            {citationText || 'Add author, year, and source details to generate the APA citation.'}
            {citationLink && (
              <a
                href={citationLink}
                target="_blank"
                rel="noreferrer"
                className="ml-2 text-indigo-600 hover:text-indigo-800 hover:underline"
              >
                {citationLink}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApaQuoteRenderer;
